import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactComponentElement} - AdminPropertyShowPrimaryBillingPoint component
 */
function AdminPropertyShowPrimaryBillingPoint(props) {
  if (!props) {
    return <Loading />;
  }

  const { primaryBillingPoint } = props;
  const { id, identifier, active } = primaryBillingPoint;

  return (
    <tr>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/primary-billing-points/${id}`}>
          {identifier}
        </Link>
        <br />
        <UUID uuid={id} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
    </tr>
  );
}

AdminPropertyShowPrimaryBillingPoint.propTypes = {
  primaryBillingPoint: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AdminPropertyShowPrimaryBillingPoint.defaultProps = {
  primaryBillingPoint: null,
};

export default AdminPropertyShowPrimaryBillingPoint;
